var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42586E",
    fillRule: "evenodd",
    d: "M10.5 17c-.256 0-.512-.098-.707-.293-.391-.39-.391-1.023 0-1.414l3.305-3.305-3.18-3.293c-.383-.398-.372-1.03.025-1.414.398-.383 1.031-.372 1.414.024l3.862 4c.379.393.374 1.016-.012 1.402l-4 4c-.195.195-.451.293-.707.293",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron-right.b0813a71.svg";
export { ForwardRef as ReactComponent };